var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseInCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.5938C10.8655 13.5938 13.5938 10.8655 13.5938 7.5C13.5938 4.13452 10.8655 1.40625 7.5 1.40625C4.13452 1.40625 1.40625 4.13452 1.40625 7.5C1.40625 10.8655 4.13452 13.5938 7.5 13.5938ZM7.5 15C11.6422 15 15 11.6422 15 7.5C15 3.35786 11.6422 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6422 3.35786 15 7.5 15ZM7.50005 6.37787L5.31255 4.19037L4.19037 5.31255L6.37787 7.50005L4.19037 9.68756L5.31255 10.8097L7.50005 8.62223L9.68756 10.8097L10.8097 9.68756L8.62223 7.50005L10.8097 5.31255L9.68756 4.19037L7.50005 6.37787Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseInCircle);
export default __webpack_public_path__ + "static/media/closeInCircle.43a11e17de86e29ec2d1411684ad930f.svg";
export { ForwardRef as ReactComponent };